
import styles from './bannerTitle.module.css';

const BannerTitle = ({title}) => (
  <span className={styles.app__banner_title}>{title}</span>
);

export default BannerTitle;
